var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EditBase, useRecordContext, useUpdate } from "react-admin";
import { ElectionDataForm } from "./ElectionDataForm";
import { ITemplateMethod } from "@/types/templates";
import { ContestsOrder } from "@sequentech/ui-core";
export var EditElectionData = function () {
    var update = useUpdate()[0];
    var record = useRecordContext();
    function updateContestsOrder(data) {
        var _a;
        (_a = data.contestsOrder) === null || _a === void 0 ? void 0 : _a.map(function (contest, index) {
            var _a;
            var electionPresentation = data.presentation;
            if ((electionPresentation === null || electionPresentation === void 0 ? void 0 : electionPresentation.contests_order) === ContestsOrder.CUSTOM) {
                var contestPresentation = ((_a = contest.presentation) !== null && _a !== void 0 ? _a : {});
                return update("sequent_backend_contest", {
                    id: contest.id,
                    data: {
                        presentation: __assign(__assign({}, contestPresentation), { sort_order: index }),
                    },
                    previousData: contest,
                });
            }
            return null;
        });
    }
    var transform = function (data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        // update contests
        updateContestsOrder(data);
        delete data.contestsOrder;
        // save receipts object
        var receipts = {};
        for (var value in Object.values(ITemplateMethod)) {
            var key = Object.keys(ITemplateMethod)[value];
            receipts[key] = {};
            receipts[key]["allowed"] = ((_a = data.allowed) === null || _a === void 0 ? void 0 : _a[key]) || false;
            receipts[key]["template"] = ((_b = data.template) === null || _b === void 0 ? void 0 : _b[key]) || null;
        }
        data.receipts = __assign({}, receipts);
        delete data.allowed;
        delete data.template;
        delete data.scheduledOpening;
        delete data.scheduledClosing;
        // save presentation object
        // language_conf
        var enabled_language_codes = [];
        for (var key in data.enabled_languages) {
            if (typeof data.enabled_languages[key] === "boolean" && data.enabled_languages[key]) {
                enabled_language_codes.push(key);
            }
        }
        var language_conf = {
            enabled_language_codes: enabled_language_codes,
        };
        // i18n
        // is alll object, no change needed
        delete data.enabled_languages;
        // name and description fields
        var fromPresentationName = ((_e = (_d = (_c = data === null || data === void 0 ? void 0 : data.presentation) === null || _c === void 0 ? void 0 : _c.i18n) === null || _d === void 0 ? void 0 : _d.en) === null || _e === void 0 ? void 0 : _e.name) ||
            ((_f = data === null || data === void 0 ? void 0 : data.presentation) === null || _f === void 0 ? void 0 : _f.i18n[Object.keys(data.presentation.i18n)[0]].name) ||
            "";
        data.name = fromPresentationName;
        var fromPresentationDescription = ((_j = (_h = (_g = data === null || data === void 0 ? void 0 : data.presentation) === null || _g === void 0 ? void 0 : _g.i18n) === null || _h === void 0 ? void 0 : _h.en) === null || _j === void 0 ? void 0 : _j.description) ||
            ((_k = data === null || data === void 0 ? void 0 : data.presentation) === null || _k === void 0 ? void 0 : _k.i18n[Object.keys(data.presentation.i18n)[0]].description) ||
            "";
        data.description = fromPresentationDescription;
        // END name, alias and description fields
        return __assign(__assign({}, data), { presentation: __assign(__assign(__assign({}, data.presentation), data.configuration), { language_conf: __assign(__assign({}, language_conf), { default_language_code: (_m = (_l = data === null || data === void 0 ? void 0 : data.presentation) === null || _l === void 0 ? void 0 : _l.language_conf) === null || _m === void 0 ? void 0 : _m.default_language_code }) }) });
    };
    return (_jsx(EditBase, __assign({ redirect: ".", transform: transform }, { children: record ? _jsx(ElectionDataForm, {}) : null })));
};
